import client from '../httpClient';

// user: /users ユーザー作成
const userCreateApi = (obj) => {
  const CREATE_USER_URL = '/users';
  return client.post(CREATE_USER_URL, JSON.stringify(obj), { isShowMessage: true });
};

export default userCreateApi;
